import { useMemo } from 'react';
import { css } from '@emotion/react';
import { SchedulingOutcomeAggregate } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { useTranslation } from '@frontend/i18n';
import { breakpoints } from '@frontend/responsiveness';
import { formatters } from '@frontend/shared';
import { theme } from '@frontend/theme';
import { InlineStats } from '../../inline-stats';
import { useCallIntelDemoFlags } from '../hooks/use-call-intel-demo-flags';

/**
 * @deprecated TODO: Remove this type when TSS Multi changes are live
 */
type Props = {
  data?: CallIntelTypes.GetOverviewStatsIO['output'];
  isLoading?: boolean;
  metricsFor?: string;
};

/**
 * @deprecated TODO: Remove this type when TSS Multi changes are live
 */
export const SubViewOpportunitiesInlineStats = ({ data, isLoading, metricsFor }: Props) => {
  const { t } = useTranslation('analytics');
  const { showDemoChipAndBanner } = useCallIntelDemoFlags();

  return (
    <InlineStats
      data={[
        {
          key: 'calls',
          name: t('{{name}} Calls', { name: metricsFor }),
          value: formatters.value(data?.totalCallsAnalyzed ?? 0),
        },
        {
          key: 'unscheduledOpportunities',
          name: t('Unscheduled Opportunities'),
          value: formatters.value(
            (data?.summary?.totalOpportunities || 0) - (data?.summary?.scheduledOpportunities || 0)
          ),
        },
        {
          key: 'conversionRate',
          name: t('Conversion Rate'),
          value: formatters.percent(
            (data?.summary?.scheduledOpportunities || 0) / (data?.summary?.totalOpportunities || 0)
          ),
        },
      ]}
      isDemoAccount={showDemoChipAndBanner}
      isLoading={isLoading}
    />
  );
};

type PropsV2 = {
  data?: SchedulingOutcomeAggregate;
  isLoading?: boolean;
  metricsFor?: string;
};

export const SubViewOpportunitiesInlineStatsV2 = ({ data, isLoading, metricsFor }: PropsV2) => {
  const { t } = useTranslation('analytics');
  const { showDemoChipAndBanner } = useCallIntelDemoFlags();

  const statsData = useMemo(
    () => [
      {
        key: 'calls',
        name: t('{{name}} Calls', { name: metricsFor }),
        value: formatters.value(data?.totalCallsAnalyzed ?? 0),
      },
    ],
    [data?.totalCallsAnalyzed, metricsFor, t]
  );

  return (
    <InlineStats
      data={statsData}
      isDemoAccount={showDemoChipAndBanner}
      isLoading={isLoading}
      wrapperStyles={styles.wrapper}
    />
  );
};

const styles = {
  wrapper: css`
    margin: 0;
    > div {
      justify-content: center;
    }
    @container (max-width: ${breakpoints.xsmall.max}px) {
      padding: ${theme.spacing(1.5, 3)};
    }
  `,
};
